import { action, get, set } from "@ember/object"
import Component from "@glimmer/component"
import type {
  Planbook,
  PlanbookDateAnnotationDateRange,
  PlanbookDateAnnotationSingle,
} from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import { objectId } from "@shared/util/object-id"
import styles from "./date-annotation.module.css"

interface Signature {
  Args: {
    planbook: Planbook
    rotationCalendar: RotationCalendar
    annotation: PlanbookDateAnnotationSingle | PlanbookDateAnnotationDateRange
    dateString: string
    location?: "onMonth"
  }
}
export default class PlanbookDateAnnotationComponent extends Component<Signature> {
  readonly styles = styles

  // state
  canShowEventMenu = false

  menuConstraints = [{ to: "window", pin: ["left"] }]

  // to make sure the menu appears on the right target
  randomId = objectId()

  // actions
  @action
  toggleSpecialEventMenu() {
    set(this, "canShowEventMenu", !get(this, "canShowEventMenu"))
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Planbook::DateAnnotation": typeof PlanbookDateAnnotationComponent
  }
}
